import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-view" }
const _hoisted_2 = { class: "register-container" }
const _hoisted_3 = { class: "agreement-section" }
const _hoisted_4 = { class: "login-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "title" }, "创建账号", -1)),
      _cache[15] || (_cache[15] = _createElementVNode("p", { class: "subtitle" }, "加入AiVitaHelper，开启您的求职之旅", -1)),
      _createVNode(_component_el_form, {
        ref: "registerFormRef",
        model: _ctx.registerForm,
        rules: _ctx.rules,
        class: "register-form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { prop: "account" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.registerForm.account,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registerForm.account) = $event)),
                placeholder: "账号",
                "prefix-icon": _ctx.User
              }, null, 8, ["modelValue", "prefix-icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "username" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.registerForm.username,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.registerForm.username) = $event)),
                placeholder: "用户名",
                "prefix-icon": _ctx.UserFilled
              }, null, 8, ["modelValue", "prefix-icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "email" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.registerForm.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.registerForm.email) = $event)),
                placeholder: "邮箱",
                "prefix-icon": _ctx.Message
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    disabled: !!_ctx.countdown || _ctx.loading,
                    onClick: _ctx.handleSendCode
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.countdown ? `${_ctx.countdown}s` : '获取验证码'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]),
                _: 1
              }, 8, ["modelValue", "prefix-icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "verificationCode" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.registerForm.verificationCode,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registerForm.verificationCode) = $event)),
                placeholder: "验证码",
                "prefix-icon": _ctx.Key
              }, null, 8, ["modelValue", "prefix-icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "password" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.registerForm.password,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.registerForm.password) = $event)),
                type: "password",
                placeholder: "密码",
                "prefix-icon": _ctx.Lock,
                "show-password": ""
              }, null, 8, ["modelValue", "prefix-icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "confirmPassword" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.registerForm.confirmPassword,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.registerForm.confirmPassword) = $event)),
                type: "password",
                placeholder: "确认密码",
                "prefix-icon": _ctx.Lock,
                "show-password": ""
              }, null, 8, ["modelValue", "prefix-icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "agreement",
            rules: [{ required: true, message: '请阅读并同意用户协议和隐私政策', trigger: 'change' }]
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.registerForm.agreement,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.registerForm.agreement) = $event))
                }, {
                  default: _withCtx(() => [
                    _cache[9] || (_cache[9] = _createTextVNode(" 我已阅读并同意 ")),
                    _createVNode(_component_router_link, {
                      to: "/user-agreement",
                      target: "_blank",
                      class: "agreement-link"
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode("《用户协议》")
                      ])),
                      _: 1
                    }),
                    _cache[10] || (_cache[10] = _createTextVNode(" 和 ")),
                    _createVNode(_component_router_link, {
                      to: "/privacy-policy",
                      target: "_blank",
                      class: "agreement-link"
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode("《隐私政策》")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "submit-btn",
            loading: _ctx.loading,
            onClick: _ctx.handleRegister
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode(" 注册 ")
            ])),
            _: 1
          }, 8, ["loading", "onClick"]),
          _createElementVNode("div", _hoisted_4, [
            _cache[13] || (_cache[13] = _createTextVNode(" 已有账号？ ")),
            _createVNode(_component_router_link, { to: "/login" }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("立即登录")
              ])),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}